
import { Component, Vue, Prop } from 'vue-property-decorator';
import { replyReservationReview } from '@/api/reservationReview';
import { ElForm } from 'element-ui/types/form';

@Component({})
export default class extends Vue {
  @Prop({ required: true }) private review!: any;

  mounted() {
    if (this.review.replyContent) {
      this.formData.replyContent = this.review.replyContent;
    }
  }

  private formData = {
    replyContent: '',
  };

  private rules = {
    replyContent: [
      { required: true, message: '답변내용을 입력하세요.', trigger: ['blur', 'change'] },
    ],
  };

  private handleSave() {
    (this.$refs.formEl as ElForm).validate((valid: boolean) => {
      if (valid) {
        replyReservationReview(this.review.idx, this.formData).then(() => {
          this.$message.success('리뷰 답변이 작성되었습니다.');
          this.$emit('success');
        });
      }
    });
  }

  private handleClose() {
    this.$emit('close');
  }
}
